import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router'
import { Button, Stack, Typography, InputBox, Row, Col, Label } from 'witmeg-ui-system'
import "./OrderPage.scss"
import { getOrderDetails } from "../../utilities/api/restaurantsService";
import { useDispatch } from "react-redux";
import { setOrderTrackingData } from "../../../../../../../redux/resturantWidgetSlice";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../utilities/helper/helper";

const OrderTrackPage = () => {
    const [value, setValue] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(false)

    const history = useHistory()
    const dispatch = useDispatch()
    useEffect(() => {
        localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_TRACK_ORDER)
    }, [])
    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null

    return (
        <div className='OrderPage order-confirmation-page'>
            <div className="Order-confirmation">
                <Typography type="title" level={1} className="eco-mb-32 eco-order-confirm-title" color="gray_darkest">Track your order</Typography>
                <div className="eco-mb-16">

                    <div className="order-form">
                        <div className="order-track-container">
                            <Row className="eco-mb-36" gutter={[16, 16]}>
                                <Col lg={12} sm={24} xs={24}>
                                    <Label>Please enter Order ID</Label>
                                    <InputBox
                                        onChange={(e) => {
                                            setValue(e.target.value)
                                            setError(false)
                                        }}
                                        type="text"
                                        value={value}

                                    />
                                    {error && <Typography className="order-error">*Invalid Order ID. Please check the order number and try again.</Typography>}
                                </Col></Row>

                            <Stack className="eco-mb-36" >
                                <Button

                                    category={isLoading ? "load-text" : "icon-text"}
                                    variant="primary" className="custom-btn full-width-btn" onClick={() => {
                                        if (value !== "" && !isLoading) {
                                            setIsLoading(true)

                                            getOrderDetails(value, storeOrderLocalData.cloudLocationID).then((response) => {
                                                if (response) {
                                                    dispatch(setOrderTrackingData(response))
                                                    setIsLoading(false)
                                                    history.push("/order/status")

                                                }
                                            }).catch(() => {
                                                setIsLoading(false)
                                                setError(true)
                                            })
                                        }
                                    }} text="Track" />
                            </Stack>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    )
}
export default OrderTrackPage